import Render from "components/Common/Render";
import PositiveFeedbackCard from "components/Home/PositiveFeedback/PositiveFeedbackCard";
import { useEffect, useRef, useState } from "react";
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";

interface IPositiveFeedbackProps {
  userFeedback: Array<UserFeedbackType> | null;
}
const PositiveFeedback: React.FC<IPositiveFeedbackProps> = ({
  userFeedback,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const scrollElement = scrollContainerRef.current;
    if (!scrollElement) return;

    setCanScrollLeft(scrollElement.scrollLeft > 0);
    setCanScrollRight(
      scrollElement.scrollLeft <
        scrollElement.scrollWidth - scrollElement.clientWidth
    );
  };

  const scroll = (direction: "left" | "right") => {
    const scrollElement = scrollContainerRef.current;
    if (!scrollElement) return;
    const isMobile = window.innerWidth <= 768;
    const scrollAmount = isMobile ? 300 : 400;

    const newScrollLeft =
      direction === "left"
        ? scrollElement.scrollLeft - scrollAmount
        : scrollElement.scrollLeft + scrollAmount;

    scrollElement.scrollTo({ left: newScrollLeft, behavior: "smooth" });
  };

  useEffect(() => {
    checkScroll(); // Initial check
    const scrollElement = scrollContainerRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", checkScroll);
      return () => scrollElement.removeEventListener("scroll", checkScroll);
    }
  }, []);

  return (
    <div>
      <div className="flex flex-row">
        <div className="text-lg font-semibold mb-4 flex-1">
          What people are saying!
        </div>
        <Render when={canScrollLeft || canScrollRight}>
          <div className="">
            <button
              onClick={() => scroll("left")}
              disabled={!canScrollLeft}
              className={`${
                !canScrollLeft ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <IoIosArrowDropleftCircle size={28} className="text-primary" />
            </button>
            <button
              onClick={() => scroll("right")}
              disabled={!canScrollRight}
              className={`${
                !canScrollRight ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <IoIosArrowDroprightCircle size={28} className="text-primary" />
            </button>
          </div>
        </Render>
      </div>
      <div
        className="flex gap-4 overflow-x-scroll no-scrollbar"
        ref={scrollContainerRef}
      >
        {userFeedback?.map((feedback: any) => {
          return <PositiveFeedbackCard userFeedback={feedback} />;
        })}
      </div>
    </div>
  );
};

export default PositiveFeedback;
